import { environment } from "./../../environments/environment";
import { PedidoService } from "./../services/pedido.service";
import { Component, OnInit, Inject, ChangeDetectorRef } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ApiService } from "../services/api.service";
import { ImpressaoService } from "../services/impressao.service";
import { SnackbarService } from "../services/snackbar.service";


@Component({
  selector: "app-modal-pedido",
  templateUrl: "./modal-pedido.component.html",
  styleUrls: ["./modal-pedido.component.css"],
})
export class ModalPedidoComponent implements OnInit {
  urlPedido = environment.baseURL;
  htmlImpressao: string = "";
  isLoading = true;

  constructor(
    public dialogRef: MatDialogRef<ModalPedidoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private pedidoService: PedidoService,
    private apiService: ApiService,
    private cd: ChangeDetectorRef,
    public impressaoService: ImpressaoService,
    private snackbarService: SnackbarService
  ) { }

  ngOnInit(): void {
    const rand = Math.random();
    const src = String(`${this.urlPedido}pedido/${this.data.Hash}?r=${rand}`);

    const pedido = this.data.Pedido;

    this.apiService.getImpressaoPedidoEscPos(pedido, this.impressaoService.numeroColunas).subscribe((response) => {
      console.log(response);
      if (response.status === "success") {
        this.isLoading = false;
        this.htmlImpressao = response.data;
        this.cd.detectChanges();
      } else {
        this.snackbarService.Error(response.data);
        this.dialogRef.close();
      }
    })

    if (this.data?.Imprimir) {
      console.log("imprimir");
      this.urlPedido = src + "&print";
      this.pedidoService.imprimirPedido(this.dialogRef);
      return;
    }
    this.urlPedido = src;
  }

  imprimir() {
    const numeroCopias = this.impressaoService?.configuracao?.numeroCopias ?? 1;

    for (let i = 0; i < numeroCopias; i++) {
      setTimeout(async () => {
        this.impressaoService.imprimirEscPos(this.htmlImpressao);
      }, 1000 * i);
    }
  }

  get htmlVisualizacao() {
    return this.htmlImpressao.replace(/\s/g, '&nbsp;');
  }

  get impressaoEstaAtiva() {
    return this.impressaoService.impressoraFoiDefinida && this.impressaoService.driverEstaAtivo;
  }
}
